import type { IErrorWallet } from '@/shared/common/types/walletError.type';

export const ErrorsWallet: IErrorWallet = {
  CONSTRAINT_VIOLATION: 'Ya existe una billetera en esa moneda. Comunícate con tu asesor',
  REQUEST_PARAMETER_NOT_VALID: 'El parametro de solicitud de la tarjeta es invalido',
  INVALID_DOCUMENT_NUMBER: 'Número de documento invalido',
  BAD_REQUEST: 'Solicitud invalida. Comunicate con tu asesor',
  FORBIDDEN: 'Acción no permitida',
  // Especific contexts for NOT_FOUND based on wallet endpoint
  NOT_FOUND: 'Recurso no encontrado',
  NOT_FOUND_PURPOSES: 'No se encuentran los propositos seleccionados',
  NOT_FOUND_ACCOUNTS: 'No se encuentra la información de las cuentas asociadas',
  NOT_FOUND_COUNTRY: 'Acción no permitida para este país',
  
  INTERNAL_SERVER_ERROR: 'Tipo de documento invalido',
  GENERIC_ERROR: 'Error en el sistema. Intenta más tarde',
  CUSTOMER_NOT_FOUND: 'Cliente no encontrado.',
} as const;
